module.exports = __webpack_public_path__ + "filter.2e7eeaabc3e49b706d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/filter.svg
// module id = ./src/assets/img/filter.svg
// module chunks = main